var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainerStacked20Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    part: "icon",
    id: "mi-container-stacked-alt",
    shapeRendering: "geometricPrecision",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v6h6a1 1 0 0 1 1 1v7H0v-7a1 1 0 0 1 1-1h2V3zm1 6h8V3H4v6zm5.5 1H1v6h8.5v-6zm1 6H19v-6h-8.5v6zm-5-8.5v-3h1v3h-1zm2 0v-3h1v3h-1zm2 0v-3h1v3h-1zm-6.5 7v-3h1v3H3zm2 0v-3h1v3H5zm2 0v-3h1v3H7zm5 0v-3h1v3h-1zm2 0v-3h1v3h-1zm2 0v-3h1v3h-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerStacked20Px);
export default __webpack_public_path__ + "static/media/container-stacked-20px.6df34d465700e93bad0a4a4ea02a16f3.svg";
export { ForwardRef as ReactComponent };